import { render } from "./404.vue?vue&type=template&id=10516e2c&scoped=true&ts=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=10516e2c&lang=scss&scoped=true"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10516e2c"]])

export default __exports__